import React from 'react';
import cx from 'classnames';
import useBuildVariantProps from '../../../../modules/theme/useBuildVariantProps';
import { WrapTextNodes } from '../../../utils/WrapTextNodes';
import styles from './TableHeaderCell.module.scss';
import type { TableHeaderCellProps } from './TableHeaderCell.types';

const TableHeaderCell = (props: TableHeaderCellProps) => {
  const {
    className,
    children,
    ...otherProps
  } = props;

  const variantProps = useBuildVariantProps(
    'table-header-cell',
    {},
    {},
  );

  return (
    <th className={cx(styles.tableHeaderCell, className)} { ...otherProps } { ...variantProps }>
      <WrapTextNodes className={styles.text}>{children}</WrapTextNodes>
    </th>
  );
};
export default TableHeaderCell;
